import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions, useMetric, useManageSubscriptionPath } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import TrafficPNG from '@crazyegginc/hatch/dist/images/illustration-traffic.png';
import TrafficWebP from '@crazyegginc/hatch/dist/images/illustration-traffic.webp';
import { ReactComponent as TickIcon } from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function TAUpgradePaywall({ mini }) {
  const { currentAccount } = useAuthContext();
  const trackMetric = useMetric();
  const subscriptionPath = useManageSubscriptionPath();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <Paywall>
      <Paywall.Image
        webp={TrafficWebP}
        fallback={TrafficPNG}
        width={mini ? '80px' : '174px'}
        className={mini ? '!mb-3 !mt-2' : ''}
      />
      <Paywall.Title mini={mini}>Compare traffic performance</Paywall.Title>

      <Paywall.Body>
        Compare the performance of referring traffic, campaigns, and landing pages against each other.
        {mini ? null : (
          <div className="mt-6 flex justify-center">
            <div className="space-y-2">
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                See what the target audience from each campaign did on your site.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                View your top 10 traffic sources and compare them to each other.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Quickly build your own analysis of the traffic you’re most interested in.
              </div>
            </div>
          </div>
        )}
        {!canManageBilling ? (
          <p className="mt-5">
            To get access to this feature, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to upgrade
            the plan.
          </p>
        ) : null}
      </Paywall.Body>

      {canManageBilling ? (
        <Button
          component={AppLink}
          to={subscriptionPath}
          onMouseDown={() => trackMetric('upgrade_cta_click', 'traffic_analysis_upsell_paywall')}
          className="mb-5"
          target={isStripeUser ? '_blank' : '_self'}
          rel={isStripeUser ? 'noopener noreferrer' : undefined}
        >
          Get Traffic Analysis
          <ArrowIcon className="ml-2.5 h-2.5 w-2.5 rotate-90 fill-current" />
        </Button>
      ) : (
        <Button component="a" href={`mailto:${currentAccount.ownerEmail}`} className="mb-5">
          Contact account owner
        </Button>
      )}
    </Paywall>
  );
}
